<script lang="ts">
    import type {RecordOperation} from 'typings/portaro.be.types';
    import {getDateFormatter} from 'core/svelte-context/context';
    import {pipe} from 'core/utils';
    import {loc} from 'shared/utils/pipes';
    import {Kind} from 'shared/constants/portaro.constants';
    import Label from 'shared/components/label/Label.svelte';

    export let recordOperation: RecordOperation;

    const dateFormatter = getDateFormatter();
</script>

<template>
    <div class="list-item-record-operation">
        <div>
            <h2 class="unset-style operation-name">
                {pipe(recordOperation.recordOperationType, loc())}
            </h2>
            <div>
                <span>{pipe(recordOperation.date, dateFormatter('d.M.yyyy'))}</span>
                <span class="text-muted">{pipe(recordOperation.date, dateFormatter('HH:mm'))}</span>
            </div>
        </div>

        <div>
            <Label labeled={recordOperation.user} explicitKind={Kind.KIND_USER}/>
        </div>

        <div>
            <Label labeled={recordOperation.record} explicitKind={Kind.KIND_RECORD} additionalClasses="record-name"/>
        </div>
    </div>
</template>

<style lang="less">
    @import (reference) "bootstrap-less/bootstrap/variables";

    .list-item-record-operation {
        display: grid;
        grid-template-columns: 2fr 1fr 2fr;
        gap: 1em;
    }

    .operation-name {
        font-weight: bold;
    }

    :global {
        .list-item-record-operation {
            .record-name {
                overflow: hidden;
                text-overflow: ellipsis;
                /* https://albertwalicki.com/learn/solutions/how-to-limit-text-to-n-lines */
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2; /* number of lines to show */
                line-clamp: 2;

                @media (max-width: @screen-xs-max) {
                    -webkit-line-clamp: 3;
                    line-clamp: 3;
                }
            }
        }
    }
</style>